import React, { lazy, Suspense } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import Auth from '../../../../Layout/Auth';

// Lazy load components
const StockTransferList = lazy(() => import('../Pages/StockTransferList'));
const AddStockTransfer = lazy(() => import('../Pages/AddStockTransfer'));
const StockTransferView = lazy(() => import('../Pages/StockTransferView'));

// Import loading overlay
import LoadingOverlay from 'react-loading-overlay';
import EditStockTransfer from "../Pages/EditStockTransfer";
import VerifyStockTransfer from "../Pages/VerifyStockTransfer";
LoadingOverlay.propTypes = undefined;

function StockTransferRoute() {
    const history = useHistory();

    return (
        <Switch>
            <Route
                exact
                path="/:lng/stock/transfer"
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff']}>
                        <Suspense fallback={<Loading />}>
                            <StockTransferList history={history} />
                        </Suspense>
                    </Auth>
                )}
            />
            <Route
                exact
                path="/:lng/stock/transfer/list"
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff']}>
                        <Suspense fallback={<Loading />}>
                            <StockTransferList history={history} />
                        </Suspense>
                    </Auth>
                )}
            />
            <Route
                exact
                path="/:lng/stock/transfer/add"
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff']}>
                        <Suspense fallback={<Loading />}>
                            <AddStockTransfer history={history} />
                        </Suspense>
                    </Auth>
                )}
            />
            <Route
                exact
                path="/:lng/stock/transfer/edit/:slack"
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff']}>
                        <Suspense fallback={<Loading />}>
                            <EditStockTransfer history={history} />
                        </Suspense>
                    </Auth>
                )}
            />
            <Route
                exact
                path="/:lng/stock/transfer/view/:slack"
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff']}>
                        <Suspense fallback={<Loading />}>
                            <StockTransferView history={history} />
                        </Suspense>
                    </Auth>
                )}
            />
            <Route
                exact
                path="/:lng/stock/transfer/verify/:slack"
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff']}>
                        <Suspense fallback={<Loading />}>
                            <VerifyStockTransfer history={history} />
                        </Suspense>
                    </Auth>
                )}
            />
        </Switch>
    );
};

export default StockTransferRoute;

function Loading() {
    return (
        <>
            <div className="wrapper">
                <span>Loading</span>
            </div>
        </>
    );
}
